import { cloneDeep } from "lodash";

export const setSurveyLoyaltyPointsOffer = ({ reward, loyaltyPoints }) => {
  reward.loyaltyPoints = loyaltyPoints;

  return cloneDeep(reward);
};

export default setSurveyLoyaltyPointsOffer;
